module.exports = __webpack_public_path__ + "img/header_eshop.19228324.jpg";